module.exports = __webpack_public_path__ + "img/googlemaps.6f379658.png";